import styled from 'styled-components'

export const DateSelectWrapper = styled.div`
  width: 100%;
`

export const SelectWrapper = styled.div`
  display: flex;
  padding: 0 40px;
  width: 100%;
`

export const AlertInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  margin: 10px 0;

  .alertInfoText {
    color: #FC3D3D;
  }
`